<template>
  <div class="incident-list-container">
    <class class="row">
      <div class="col">
        <KeyRound /> ID
      </div>
      <div class="col">
        <Store /> Expendeduria
      </div>
      <div class="col">
        <Calculator /> Máquina
      </div>
      <div class="col">
        <SquareCheck /> Estado
      </div>
      <div class="col">
        <CalendarClock /> Fecha y Hora
      </div>
    </class>
    <div class="row">
      <div class="col">
        <div class="accordion" id="accordionFaq">
          <!-- <div v-for="(item, index) in faqs" :key="index" class="accordion-item"> -->
            
          <component
            v-for="incident in store.sortedIncidents"
            :is="store.isDetailed(incident.id) ? IncidentDetailComponent : IncidentItemComponentAux"
            :key="incident.id"
            :incident="incident"
          />
            
          </div>
        </div>
      </div>
    </div>
  
</template>

<script setup lang="ts">
import { useIncidentStore } from '@/stores/useIncidentStore';
import IncidentDetailComponent from './IncidentDetailComponent.vue';
import { Incident } from '@/types/incidentsTypes';
//import PaginationControls from '@/core/components/PaginationControls.vue';
import { onMounted } from 'vue';
import IncidentItemComponent from './IncidentItemComponent.vue';
import { Calculator, Store, CalendarClock, SquareCheck, KeyRound, Pencil } from 'lucide-vue-next';
import IncidentItemComponentAux from './IncidentItemComponentAux.vue';

const store = useIncidentStore();

// Carga inicial
onMounted(async () => {
  if (!store.incidents.length) {
    await store.fetchIncidents();
  }
});
</script>

<style scoped lang="scss">
.incident-list-container {
  position: relative;
  min-height: 300px;
}

.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-body {
  ul {
    li {
      margin-bottom: 0.5rem;
      strong {
        display: inline-block;
        width: 120px;
      }
    }
  }
}
</style>